<!-- LOADER SVG -->
<div class="loader" [ngClass]="classes" title="loader icon">
    <svg version="1.1" id="loader-svg"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 30" width="100%" height="100%" xml:space="preserve">
    <rect x="0" y="13" width="4" height="5" fill="#000" class="bar1">
      <animate attributeName="height" attributeType="XML"
               values="5;21;5"
               begin="0s" dur="0.6s" repeatCount="indefinite"/>
        <animate attributeName="y" attributeType="XML"
                 values="13; 5; 13"
                 begin="0s" dur="0.6s" repeatCount="indefinite"/>
    </rect>
        <rect x="10" y="13" width="4" height="5" fill="#000" class="bar2">
      <animate attributeName="height" attributeType="XML"
               values="5;21;5"
               begin="0.15s" dur="0.6s" repeatCount="indefinite"/>
            <animate attributeName="y" attributeType="XML"
                     values="13; 5; 13"
                     begin="0.15s" dur="0.6s" repeatCount="indefinite"/>
    </rect>
        <rect x="20" y="13" width="4" height="5" fill="#000" class="bar3">
      <animate attributeName="height" attributeType="XML"
               values="5;21;5"
               begin="0.3s" dur="0.6s" repeatCount="indefinite"/>
            <animate attributeName="y" attributeType="XML"
                     values="13; 5; 13"
                     begin="0.3s" dur="0.6s" repeatCount="indefinite"/>
    </rect>
  </svg>
</div>
